import { Typography } from '@mui/material'
import { InsightItem } from 'components/core/insights'
import { CostInsight, InsightType } from 'pbts/c1/api/task/v1/insights'
import React, { FC } from 'react'
import { FormattedMessage } from 'react-intl'

type CostProps = {
    cost: CostInsight
    insightType: InsightType
}

export const Cost: FC<CostProps> = ({ cost, insightType }) => {
    return (
        <InsightItem key="cost" insightType={insightType}>
            <Typography>
                <FormattedMessage
                    id="components_insights_cost"
                    defaultMessage="This application has a <b>seat cost of ${seat_cost} USD/month</b>"
                    values={{
                        b: (chunks) => <b>{chunks}</b>,
                        seat_cost: cost.monthlyCostUsd,
                    }}
                />
            </Typography>
        </InsightItem>
    )
}
export default Cost
